<template>
    <div class="rcheck_upload" v-loading="loading">
        <div class="rcheck_upload_title">{{ this.$t('upload.title') }}</div>
        <div class="rcheck_upload_step">
            <div v-for="(item, index) in $t('upload.stepList')" :key="index" class="rcheck_upload_step_item">
                <span class="rcheck_upload_step_item_text">{{ item }}</span>
                <img src="./static/right_arrow.svg" v-if="index < upload.stepList.length - 1"
                    class="rcheck_upload_step_item_arrow">
            </div>
        </div>
        <div class="rcheck_upload_content">
            <div class="rcheck_upload_content_desc">{{ this.$t('upload.desc') }}</div>
            <div class="rcheck_upload_content_upload">
                <el-upload drag :http-request="uploadHttpRequest" :before-upload="onUploadBefore"
                    :on-remove="onUploadRemove" :accept="accept" action="#" :limit="2" :file-list="fileList"
                    :style="uploadedFile ? { filter: 'opacity(0.5)' } : {}">
                    <div class="rcheck_upload_content_upload_box" v-if="!uploadedFile">
                        <img src="./static/add.png" class="rcheck_upload_content_upload_box_add">
                        <div class="rcheck_upload_content_upload_box_text">{{ this.$t('upload.uploadDescribe') }}</div>
                        <div class="rcheck_upload_content_upload_box_format">
                            <img src="./static/pdf.png" class="rcheck_upload_content_upload_box_pdf">
                        </div>
                    </div>
                    <div v-else class="rcheck_upload_content_file">
                        <img src="./static/file.png">
                        <div>{{ uploadedFile.name }}</div>
                    </div>
                </el-upload>
            </div>

            <div class="rcheck_upload_content_btn_box">
                <div class="rcheck_upload_content_btn" @click="changeComponent">
                    <img src="./static/light.png" class="loading-img" />
                    <div>
                        {{ this.$t('upload.btn') }}
                    </div>
                </div>
            </div>
        </div>

        <!-- <NotOrcidDialog ref="notOrcidDialogRef"></NotOrcidDialog> -->
    </div>
</template>

<script>
import { pageEditor } from "./data";
import { rcheckUpload } from "./api/index"
// import NotOrcidDialog from "@/views/notOrcidDialog.vue";

export default {
    emits: ["change:component", 'update:upload', 'update:data'],
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        uploadedFile: {
            type: File,
            default: null
        }
    },
    components: {
        // NotOrcidDialog
    },
    data() {
        const { upload } = pageEditor

        return {
            upload,
            loading: false,
            uploadType: ['application/pdf'],
            accept: ".pdf"
        }
    },
    computed: {
        fileList() {
            return this.uploadedFile ? [this.uploadedFile] : [];
        }
    },
    methods: {
        async changeComponent() {
            // if (this.checkUrlForContrimetric()) {
            //     if (!this.permissionCheck()) {
            //         return
            //     }

            //     if (!this.permissionSimUserInfo()) {
            //         return
            //     }
            // }

            if (!this.uploadedFile) {
                this.$message.warning(this.$t('upload.notUploadedTip'));
                return;
            }

            this.loading = true;

            if (this.data) {
                setTimeout(() => {
                    this.$emit("change:component", "Contant");
                    this.loading = false;
                }, 200);

                return
            }

            try {
                const parsedData = await this.parseUploadedFile(this.uploadedFile);

                this.$emit("update:data", parsedData);
                this.$emit("change:component", "Contant");
            } catch (error) {
                this.$message.error(this.$t('upload.errorAnalyze'));
                console.error(this.$t('upload.errorAnalyze'), error);
            } finally {
                setTimeout(() => {
                    this.loading = false;
                }, 200);
            }
        },
        checkUrlForContrimetric() {
            const currentUrl = window.location.href;
            return currentUrl.includes('contrimetric');
        },
        // 贡献计量学 - ReCheck 组件新增权限校验，必须登录且绑定用户信息
        permissionCheck() {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));

            if (userInfo == null || userInfo == "") {
                this.$loginDialog.openDialog()

                return false
            }

            // if (userInfo.userId == -1) {
            //     this.$refs.notOrcidDialogRef.openDialog(userInfo)

            //     return false
            // }

            return true
        },
        permissionSimUserInfo() {
            const simUserInfo = JSON.parse(localStorage.getItem('simUserInfo'));
            console.log(simUserInfo);

            if (simUserInfo == null || simUserInfo == "") {
                this.$store.commit('setTokenInfo', "")
                this.$store.commit('setUserInfo', "")
                this.$store.commit('setIsLogin', "")

                this.$message.warning(this.$t('upload.errorLoginAbnormalType'));
                this.$loginDialog.openDialog()

                return false
            }

            return true
        },
        onUploadBefore(file) {
            if (!this.uploadType.includes(file.type)) {
                this.$message.warning(this.$t('upload.errorUploadType'));
                return false
            }
        },
        async uploadHttpRequest(file) {
            if (this.uploadedFile) {
                this.$emit("update:data", null)
            }

            try {
                this.$emit("update:upload", file.file)
                this.$message.success(this.$t('upload.successUpload'));
            } catch (error) {
                this.$message.error(this.$t('upload.errorUpload'));
                console.error(this.$t('upload.errorUpload'), error);
            }
        },
        onUploadRemove() {
            this.$emit("update:upload", null)
            this.$emit("update:data", null);
        },
        async parseUploadedFile(file) {
            console.log("dscdsfs",file);
            // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            // const simUserInfo = JSON.parse(localStorage.getItem('simUserInfo'));
    
            const formData = new FormData();

            formData.append('files', file);
            // formData.append('name', userInfo.userName);
            // formData.append('orcid', userInfo.oauthId == void (0) ? "" : userInfo.oauthId);
            formData.append('sourceType', 'jiannu_web');
            // formData.append('account', simUserInfo.account);
            // formData.append('email', simUserInfo.email);

            const response = await rcheckUpload(formData);
            const data = response.data[0];
            const { articleStatisticsDTO, map, paperDetails } = data;
            const {
                LAST_TWO_YEARS, NEARLY_THREE_TO_FIVE_YEARS, OVER_FIVE_YEARS,
                BASE_JOURNAL, BASE_OTHERS, DISTRIBUTION_WOS, DISTRIBUTION_SCOPUS, DISTRIBUTION_GENERAL,
                ANNUAL_TWO, ANNUAL_THREE_TO_FIVE, ANNUAL_FIVE
            } = this.categorizeYears(map.ALL_REFERENCE, this.getPublisherYear(paperDetails.publisherYear))

            data.frontData = {}
            data.frontData.BASE_JOURNAL = BASE_JOURNAL;
            data.frontData.BASE_OTHERS = BASE_OTHERS;
            data.frontData.DISTRIBUTION_WOS = DISTRIBUTION_WOS;
            data.frontData.DISTRIBUTION_SCOPUS = DISTRIBUTION_SCOPUS;
            data.frontData.DISTRIBUTION_GENERAL = DISTRIBUTION_GENERAL;
            data.frontData.ANNUAL_TWO = ANNUAL_TWO;
            data.frontData.ANNUAL_THREE_TO_FIVE = ANNUAL_THREE_TO_FIVE;
            data.frontData.ANNUAL_FIVE = ANNUAL_FIVE;

            articleStatisticsDTO.nojournalCount = articleStatisticsDTO.count - articleStatisticsDTO.journalCount;
            articleStatisticsDTO.noWosCount = articleStatisticsDTO.count - articleStatisticsDTO.wosCount;
            articleStatisticsDTO.noScopusCount = articleStatisticsDTO.count - articleStatisticsDTO.scopusCount;
            articleStatisticsDTO.twoTotal = LAST_TWO_YEARS.length;
            articleStatisticsDTO.ttofTotal = NEARLY_THREE_TO_FIVE_YEARS.length;
            articleStatisticsDTO.fiveTotal = OVER_FIVE_YEARS.length;

            map.total = map.ALL_REFERENCE.length;
            map.twoTotal = LAST_TWO_YEARS.length;
            map.ttofTotal = NEARLY_THREE_TO_FIVE_YEARS.length;
            map.fiveTotal = OVER_FIVE_YEARS.length;
            map.retractedTotal = map.RETRACTED.length;

            console.log("解析后的数据：", data);
            return data;
        },
        categorizeYears(arr, year) {
            const LAST_TWO_YEARS = [];
            const NEARLY_THREE_TO_FIVE_YEARS = [];
            const OVER_FIVE_YEARS = [];
            const BASE_JOURNAL = []
            const BASE_OTHERS = []
            const DISTRIBUTION_WOS = []
            const DISTRIBUTION_SCOPUS = []
            const DISTRIBUTION_GENERAL = []
            const ANNUAL_TWO = []
            const ANNUAL_THREE_TO_FIVE = []
            const ANNUAL_FIVE = []

            const parsedYear = parseInt(year);

            arr.forEach(item => {
                if (item.journalType == 0) {
                    BASE_JOURNAL.push(item)
                } else {
                    BASE_OTHERS.push(item)
                }

                if (item.wos == 'yes') DISTRIBUTION_WOS.push(item)

                if (item.scopus == 'yes') DISTRIBUTION_SCOPUS.push(item)

                if (item.wos != 'yes' && item.scopus != 'yes') DISTRIBUTION_GENERAL.push(item)

                if (item.year === "") console.warn(`Invalid year in item: ${JSON.stringify(item)}`);

                const itemYear = parseInt(item.year);

                if (isNaN(itemYear)) {
                    console.warn(`Invalid year in item: ${JSON.stringify(item)}`);
                    return;
                } else {
                    if (itemYear === parsedYear || itemYear === parsedYear - 1) {
                        LAST_TWO_YEARS.push(item);
                        ANNUAL_TWO.push(item)
                    } else if (itemYear >= parsedYear - 5 && itemYear <= parsedYear - 2) {
                        NEARLY_THREE_TO_FIVE_YEARS.push(item);
                        ANNUAL_THREE_TO_FIVE.push(item)
                    } else if (itemYear <= parsedYear - 5) {
                        OVER_FIVE_YEARS.push(item);
                        ANNUAL_FIVE.push(item)
                    }
                }
            });

            return {
                LAST_TWO_YEARS,
                NEARLY_THREE_TO_FIVE_YEARS,
                OVER_FIVE_YEARS,
                BASE_JOURNAL,
                BASE_OTHERS,
                DISTRIBUTION_WOS,
                DISTRIBUTION_SCOPUS,
                DISTRIBUTION_GENERAL,
                ANNUAL_TWO,
                ANNUAL_THREE_TO_FIVE,
                ANNUAL_FIVE
            };
        },
        getPublisherYear(year) {
            if (year === "" || year === null) {
                return new Date().getFullYear();
            }

            return year;
        },
        getTotalArrayLength(obj) {
            let totalLength = 0;

            for (const key in obj) {
                if (Array.isArray(obj[key])) {
                    totalLength += obj[key].length;
                }
            }

            return totalLength;
        }
    }
}
</script>

<style lang='scss'>
@import "./style.scss";
</style>